import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';

import { I18nResources, useI18n } from '@app-velocity/i18n';

import { WhereToStartLinks } from '../WhereToStartLinks';

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  lineHeight: 1.3,
}));

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  textAlign: 'center',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export type WhereToStartProps = {
  title: I18nResources;
};

export const WhereToStart = ({ title }: WhereToStartProps) => {
  const { t } = useI18n();

  return (
    <StyledContainer>
      <StyledSubtitle>{t(title)}</StyledSubtitle>
      <WhereToStartLinks variant="contained" />
    </StyledContainer>
  );
};
